<!--
    说明：用户权益相关内容，还可能会有提示，如：沉迷游戏伤身，合理安排时间。
    创建时间：2022/6/27
    创建者：congpeizhi
-->
<template>
    <div class="detail-equity">
        <!-- 用户权益 -->
        <div class="detail-equity-rights" @click="checkRightArrow">
            <div class="detail-equity-rights_title">权益</div>
            <div class="detail-equity-rights_content">
                <div
                    class="detail-equity-rights_content_item"
                    v-for="(item, index) in dataTags"
                    :key="index"
                >
                    <img
                        v-if="item.tag === '不支持无理由退款'"
                        src="../img/no_rights_.png"
                    />
                    <img v-else src="../img/rights.png" />{{ item.tag }}
                </div>
            </div>
            <img
                class="detail-equity-rights_arrow"
                :class="{ 'detail-equity-rights_arrowAndroid': isAndroid }"
                src="../img/arrow1.png"
            />
        </div>
        <!-- 用户提示，录入防沉迷 -->
        <div
            v-if="tipsFlag && dataCourse.courseType !== 'LIVE_ONLY'"
            class="detail-equity-tips"
            @click="checkTipRightArrow"
        >
            <div class="detail-equity-tips_title">提示</div>
            <div class="detail-equity-tips_content">
                <div
                    class="detail-equity-tips_content_item"
                    v-if="dataCourse.notSupportRefundNoReason"
                >
                    <img src="../img/no_rights_.png" />
                    <span>不支持无理由退款</span>
                </div>
                <div
                    class="detail-equity-tips_content_item"
                    v-if="dataCourse.courseType == 'OFF_SITE_COURSE'"
                >
                    <img src="../img/dark_off_24.svg" />
                    <span>站外课不在快手app内观看学习</span>
                    <span
                        class="receive-btn"
                        @click="handleReceive"
                        v-if="isShowReceive"
                        >领取课程</span
                    >
                </div>
                <div
                    class="detail-equity-tips_content_item"
                    v-if="dataCourse.category == 'GAME'"
                >
                    <img src="../img/dark_off_24.svg" />
                    <span>沉迷游戏伤身，合理安排时间</span>
                </div>
                <div
                    class="detail-equity-tips_content_item"
                    v-if="dataCourse.subCategory === 'COURSE_PHOTOGRAPH'"
                >
                    <img src="../img/dark_off_24.svg" />
                    <span>视频中的素材或软件仅供示例</span>
                </div>
            </div>
            <div
                class="detail-equity-tips_icon"
                v-if="
                    dataCourse.notSupportRefundNoReason ||
                    dataCourse.courseType == 'OFF_SITE_COURSE'
                "
            >
                <img
                    class="detail-equity-tips_icon_arrow"
                    :class="{ 'detail-equity-tips_arrowAndroid': isAndroid }"
                    src="../img/arrow1.png"
                />
            </div>
        </div>
        <!-- 权益说明弹窗，点击权益箭头唤起 -->
        <PopUp ref="rightPopUp" :title="'基础权益'" @popUpBottom="popUpBottom">
            <!-- 各项权益 -->
            <div class="detail-equity-tags">
                <div
                    class="detail-equity-tags_items"
                    v-for="(item, index) in dataTags"
                    :key="index"
                >
                    <p
                        class="detail-equity-tags_items_tag"
                        :class="{
                            'detail-equity-tags_items_tag_gray':
                                item.tag.indexOf('不支持') > -1,
                        }"
                    >
                        {{ item.tag }}
                    </p>
                    <p class="detail-equity-tags_items_explaination">
                        {{ item.explaination }}
                    </p>
                </div>
            </div>
        </PopUp>
        <!-- 提示说明弹窗，点击提示箭头唤起 -->
        <PopUp
            ref="tipRightPopUp"
            :title="'购买提示'"
            @popUpBottom="tipPopUpBottom"
        >
            <div class="detail-equity-tags">
                <div
                    class="detail-equity-tags_items"
                    v-if="dataCourse.notSupportRefundNoReason"
                >
                    <p class="detail-equity-tags_items_tag_gray">
                        不支持无理由退款
                    </p>
                    <p class="detail-equity-tags_items_explaination">
                        虚拟内容和服务购买后不支持无理由退款，请谨慎购买
                    </p>
                </div>
                <div
                    class="detail-equity-tags_items"
                    v-if="dataCourse.courseType == 'OFF_SITE_COURSE'"
                >
                    <p class="detail-equity-tags_items_tag_tip">
                        站外课不在快手app内观看学习
                    </p>
                    <p class="detail-equity-tags_items_explaination">
                        站外课不在快手app内观看和学习！购买后该课程老师会主动联系您安排后续上课学习事宜
                    </p>
                </div>
            </div>
        </PopUp>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue';
import { CourseDetailTags, CourseDetailCourse, UserRole } from '../service';
import PopUp from './common/PopUp.vue';
import { isAndroid } from '@/utils/env';
export default defineComponent({
    components: {
        PopUp,
    },
    props: {
        // 权益
        dataTags: {
            type: Array as PropType<CourseDetailTags[]>,
            default: () => {
                return [];
            },
        },
        // 课程相关信息
        dataCourse: {
            type: Object as PropType<CourseDetailCourse>,
            default: () => {
                return {};
            },
        },
        // 用户角色信息
        dataUserRole: {
            type: Object as PropType<UserRole>,
            default: () => {
                return {};
            },
        },
    },
    setup(props, ctx) {
        // 获取权益弹窗组件
        const rightPopUp = ref();
        const tipRightPopUp = ref();
        // 提示信息是否展示
        const tipsFlag = computed(() => {
            // 只有当是站外课 || 游戏类型 || 剪辑视频类型 || 不支持无理由退款则展示提示文案，对应四种不同文案
            if (
                props.dataCourse.courseType === 'OFF_SITE_COURSE' ||
                props.dataCourse.category === 'GAME' ||
                props.dataCourse.subCategory === 'COURSE_PHOTOGRAPH' ||
                props.dataCourse.notSupportRefundNoReason
            ) {
                return true;
            }
            return false;
        });
        // 领取权益按钮
        const isShowReceive = computed(() => {
            return (
                props.dataUserRole.role === 'STUDENT' &&
                [1, 2].includes(props.dataCourse.contentAcquisitionMode || 0)
            );
        });
        /**
         * 点击权益箭头，弹出权益详细弹窗
         */
        const checkRightArrow = () => {
            // 直接调子组件的fun，唤起弹窗
            rightPopUp.value.showPopUp();
        };
        /**
         * 点击权益底部弹窗按钮，触发事件
         */
        const popUpBottom = () => {
            // 直接调子组件的fun，唤起弹窗
            rightPopUp.value.closePop();
        };
        /**
         * 点击提示箭头，弹出提示详细弹窗
         */
        const checkTipRightArrow = () => {
            if (
                !props.dataCourse.notSupportRefundNoReason &&
                props.dataCourse.courseType !== 'OFF_SITE_COURSE'
            ) {
                return;
            }
            tipRightPopUp.value.showPopUp();
        };
        /**
         * 点击提示底部弹窗按钮，触发事件
         */
        const tipPopUpBottom = () => {
            tipRightPopUp.value.closePop();
        };
        const handleReceive = (event) => {
            event.stopPropagation();
            ctx.emit('handleReceive');
        };
        return {
            checkRightArrow,
            checkTipRightArrow,
            rightPopUp,
            tipRightPopUp,
            popUpBottom,
            tipPopUpBottom,
            tipsFlag,
            isAndroid,
            handleReceive,
            isShowReceive,
        };
    },
});
</script>

<style lang="less" scoped>
.detail-equity {
    background-color: #fff;
    border-radius: 8px;
    margin: 12px 10px 0;
    font-family: 'PingFang SC';
    .detail-equity-rights {
        display: flex;
        // height: 50px;
        align-items: flex-start;
        padding: 0 12px;
        position: relative;
        &_arrow {
            width: 12px;
            height: 12px;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            right: 12px;
        }
        &_arrowAndroid {
            margin-top: 1px;
        }
        &_title {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #9c9c9c;
            line-height: 50px;
            height: 50px;
            width: 29px;
            white-space: nowrap;
        }
        &_content {
            width: 320px;
            margin-left: 8px;
            font-weight: 400;
            font-size: 14px;
            color: #666;
            display: flex;
            flex-wrap: wrap;
            padding: 8px 0 16px;
            &_item {
                display: flex;
                align-items: center;
                height: 18px;
                line-height: 20px;
                margin-top: 8px;
                img {
                    width: 14px;
                    height: 14px;
                    margin-left: 8px;
                    margin-right: 2px;
                }
            }
        }
    }
    .detail-equity-tips {
        padding: 0 12px 15px;
        display: flex;
        align-items: flex-start;
        &_icon {
            padding-top: 6px;
            &_arrow {
                width: 12px;
                height: 12px;
                transform: translate(0, -50%);
                right: 12px;
            }
        }
        &_arrowAndroid {
            margin-top: 1px;
        }
        &_title {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #9c9c9c;
            line-height: 18px;
            width: 29px;
            white-space: nowrap;
        }
        &_content {
            width: 320px;
            margin-left: 8px;
            font-weight: 400;
            font-size: 14px;
            color: #666;
            flex: 1;
            &_item {
                height: 18px;
                display: flex;
                align-items: center;
                margin-top: 8px;
                flex-wrap: wrap;
                .receive-btn {
                    display: flex;
                    flex: 1;
                    justify-content: flex-end;
                    color: #326bfb;
                }
            }
            img {
                width: 14px;
                height: 14px;
                margin-left: 8px;
                margin-right: 2px;
            }
        }
        .detail-equity-tips_content_item:nth-child(1) {
            margin-top: 0;
        }
    }
}
.detail-equity-tags {
    padding: 24px 48px 0 45px;
    &_items {
        margin-bottom: 32px;
        &_tag {
            font-weight: 500;
            font-size: 14px;
            color: #222;
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 18px;
                height: 18px;
                background: url(../img/rights_.png);
                background-size: 100% 100%;
                position: absolute;
                left: -28px;
                top: 1px;
            }
        }
        &_tag_gray {
            font-weight: 500;
            font-size: 14px;
            color: #222;
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 18px;
                height: 18px;
                background: url(../img/no_rights.png);
                background-size: 100% 100%;
                position: absolute;
                left: -28px;
                top: 1px;
            }
        }
        &_tag_tip {
            font-weight: 500;
            font-size: 14px;
            color: #222;
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 18px;
                height: 18px;
                background: url(../img/Vector.svg);
                background-size: 100% 100%;
                position: absolute;
                left: -28px;
                top: 1px;
            }
        }
        &_explaination {
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #9c9c9c;
            margin-top: 5px;
        }
    }
    &_items:last-child {
        margin: 0;
    }
}
</style>
